export enum StorageContext {
  Local = "Local",
  Remote = "Remote",
  External = "External",
}
